export { default as RichTextRenderer } from './RichTextRenderer';
